
const patientGroups = [
  {
    id: 'children',
    label: 'Kinder',
    image: require('../../assets/img/patientgroups/children.png'),
    image2x: require('../../assets/img/patientgroups/children_2x.png'),
    image3x: require('../../assets/img/patientgroups/children_3x.png'),
    enabled: true,
  },
  {
    id: 'adults',
    label: 'Erwachsene',
    image: require('../../assets/img/patientgroups/adults.png'),
    enabled: false,
  },
  {
    id: 'caredependents',
    label: 'Pflegebedürftige',
    image: require('../../assets/img/patientgroups/caredependents.png'),
    enabled: false,
  },
]

export default patientGroups
